<div v-if="shouldRenderConfig" v-bind:class="getClassName">
    <div v-if="getProductSpineWidth" class="matrix_tableHeader">
        {{$t('Weight & Spine Width')}}
    </div>
    <div v-else class="matrix_tableHeader">
        {{$t('Weight')}}
    </div>
    <div :class="getClassName + 'Content'">
        <!-- <div
            v-bind:class="getClassNameItem"
            v-for="(item,index) in getInformation"
            v-bind:key="index">                
            <span class="matrix_informationLabel">{{$t(item.label)}}</span>: <span class="matrix_informationValue">{{item.value}}</span>
        </div> -->
        <div>
            <span class="matrix_informationLabel"> {{$t('Approx Weight Per Item: ')}} </span>
            <span class="matrix_informationValue"> {{ getProductWeight }} </span>
        </div>
        <div v-if="getProductSpineWidth">
            <span class="matrix_informationLabel"> {{$t('Spine Width: ')}} </span>
            <span class="matrix_informationValue"> {{ getProductSpineWidth }} </span>
        </div>
    </div>
</div>

